<template>
  <div
    class="input-field"
    :class="{
      'input-field--readonly': this.readonly,
      'input-field--disabled': this.disabled,
      'input-field--vertical': this.vertical,
      'input-field--stretch': this.stretch,
      'input-field--spacing-off': this.spacingOff,
      'input-field--text-group': this.textGroup
    }"
  >
    <input
      :tooltip="tooltip"
      autocomplete="off"
      v-if="inputOut"
      v-bind="$attrs"
      :id="id"
      :value="value"
      v-model="modelValue"
      :placeholder="placeholder"
      :readonly="readonly"
      :disabled="disabled"
      v-on="inputListeners"
    />
    <cleave
      :tooltip="tooltip"
      autocomplete="off"
      v-else-if="vMoney"
      :options="format"
      :placeholder="placeholder"
      :readonly="readonly"
      :disabled="disabled"
      :id="id"
      :value="value"
      v-on="inputListeners"
    ></cleave>
    <input
      :tooltip="tooltip"
      autocomplete="off"
      v-else
      v-bind="$attrs"
      :id="id"
      :value="value"
      :placeholder="placeholder"
      :readonly="readonly"
      :disabled="disabled"
      v-on="inputListeners"
      :style="(bold ? 'font-weight: bold;' : '') + (fontSize != '' ? `font-size: ${fontSize};` : '')"
    />
    <label :for="id" class="input-field__label">
      <slot></slot>
    </label>
    <slot name="helper"></slot>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    value: {
      required: false
    },
    id: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      required: false
    },
    readonly: {
      type: Boolean,
      required: false
    },
    disabled: {
      type: Boolean,
      required: false
    },
    stretch: {
      type: Boolean,
      required: false
    },
    spacingOff: {
      type: Boolean,
      required: false
    },
    textGroup: {
      type: Boolean,
      required: false
    },
    vertical: {
      type: Boolean,
      required: false
    },
    inputOut: {
      type: Boolean,
      required: false
    },
    vMoney: {
      type: Boolean,
      default: false
    },
    format: Object,
    tooltip: {
      type: String,
      default: null,
      required: false
    },
    bold: {
      type: Boolean,
      default: false,
      required: false
    },
    fontSize: {
      type: String,
      default: "",
      required: false
    },
  },
  data() {
    return {
      labelActive: false,
      modelValue: this.value
    }
  },
  mounted() {
    if (this.inputOut && !this.value) {
      this.modelValue = this.value
    }

  },
  computed: {
    inputListeners: function () {
      var vm = this
      return Object.assign({},
        this.$listeners,
        {
          input: function (event) {
            if (event.target !== null && event.target !== undefined) {
              let value = event.target.value
              vm.$emit('input', value)
            }
            else {
              let value = event;
              vm.$emit('input', value)
            }
          },
          focus: function (event) {
            // 
          },
          blur: function (event) {
            // 
          }
        }
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/element/InputField.vue